// hooks/useValidateSingleAddress.js

import { useLoqateAddress } from './useLoqateAddress';
import { useModal } from './useModal';

export const useValidateSingleAddress = () => {
  const { getValidatedAddress } = useLoqateAddress();
  const { setModalOpen, setModalMessage } = useModal();

  const validateSingleAddress = async (formData) => {
    try {
      const addressInput = {
        Options: { Enhance: true },
        Addresses: [
          {
            Address1:
              formData.addressLine1 ||
              formData.uboCharityAddress ||
              formData.uboRegisteredOfficeAddress ||
              formData.uboBusinessAddress ||
              formData.uboRegisteredAddress ||
              formData.uboLegalPersonRegisteredOfficeAddress ||
              formData.uboAddress ||
              formData.uboaddressLine1 ||
              "",
            Address2: formData.addressLine2 || formData.uboaddressLine2 || "",
            Address3: formData.addressLine3 || formData.uboaddressLine3 || "",
            Country:
              formData.country ||
              formData.countryOfIncorporation ||
              formData.uboCountry ||
              formData.ubocountry ||
              "",
            Locality: formData.city || formData.ubocity || "",
            PostalCode: formData.postcode || formData.postCode || formData.ubopostalCode || "",
          },
        ],
      };

      const inputCountry = addressInput.Addresses[0].Country;

      if (inputCountry !== "United Kingdom") {
        console.info("Address validation skipped: Country is not United Kingdom");
        return formData;
      }

      const validatedAddress = await getValidatedAddress(addressInput);

      console.log("formData in handleValidateAddress:", formData);
      console.log("validatedAddress:", validatedAddress);

      if (!validatedAddress) {
        console.warn("⚠️ Loqate returned no match");
        return "No Response";
      }

      // Map the Loqate response fields back onto your form structure
      return {
        ...formData,

        ...(formData.addressLine1 !== undefined
          ? { addressLine1: validatedAddress.Address1 || formData.addressLine1 }
          : {}),

        ...(formData.uboaddressLine1 !== undefined
          ? { uboaddressLine1: validatedAddress.Address1 || formData.uboaddressLine1 }
          : {}),

        ...(formData.uboaddressLine2 !== undefined
          ? { uboaddressLine2: validatedAddress.Address2 || formData.uboaddressLine2 }
          : {}),

        ...(formData.uboaddressLine3 !== undefined
          ? { uboaddressLine3: validatedAddress.Address3 || formData.uboaddressLine3 }
          : {}),

        ...(formData.addressLine2 !== undefined
          ? { addressLine2: validatedAddress.Address2 || formData.addressLine2 }
          : {}),

        ...(formData.addressLine3 !== undefined
          ? { addressLine3: validatedAddress.Address3 || formData.addressLine3 }
          : {}),

        ...(formData.city !== undefined
          ? { city: validatedAddress.Locality || formData.city }
          : formData.ubocity !== undefined
          ? { ubocity: validatedAddress.Locality || formData.ubocity }
          : {}),

        ...(formData.state !== undefined
          ? { state: validatedAddress.AdministrativeArea || formData.state }
          : {}),

        ...(formData.uboCharityAddress !== undefined
          ? { uboCharityAddress: validatedAddress.Address || formData.uboCharityAddress }
          : {}),

        ...(formData.uboRegisteredOfficeAddress !== undefined
          ? {
              uboRegisteredOfficeAddress:
                validatedAddress.Address || formData.uboRegisteredOfficeAddress,
            }
          : {}),

        ...(formData.uboBusinessAddress !== undefined
          ? { uboBusinessAddress: validatedAddress.Address || formData.uboBusinessAddress }
          : {}),

        ...(formData.uboRegisteredAddress !== undefined
          ? { uboRegisteredAddress: validatedAddress.Address || formData.uboRegisteredAddress }
          : {}),

        ...(formData.uboLegalPersonRegisteredOfficeAddress !== undefined
          ? {
              uboLegalPersonRegisteredOfficeAddress:
                validatedAddress.Address ||
                formData.uboLegalPersonRegisteredOfficeAddress,
            }
          : {}),

        ...(formData.uboAddress !== undefined
          ? { uboAddress: validatedAddress.Address || formData.uboAddress }
          : {}),

        ...(formData.postcode !== undefined
          ? { postcode: validatedAddress.PostalCode || formData.postcode }
          : formData.postCode !== undefined
          ? { postCode: validatedAddress.PostalCode || formData.postCode }
          : formData.ubopostalCode !== undefined
          ? { ubopostalCode: validatedAddress.PostalCode || formData.ubopostalCode }
          : {}),

        ...(formData.country !== undefined
          ? { country: validatedAddress.CountryName || formData.country }
          : formData.countryOfIncorporation !== undefined
          ? {
              countryOfIncorporation:
                validatedAddress.CountryName ||
                formData.countryOfIncorporation,
            }
          : formData.ubocountry !== undefined
          ? {
              ubocountry:
                validatedAddress.CountryName ||
                formData.ubocountry,
            }
          : formData.uboCountry !== undefined
          ? {
              uboCountry:
                validatedAddress.CountryName ||
                formData.uboCountry,
            }
          : formData.CountryName !== undefined
          ? { CountryName: validatedAddress.CountryName || formData.CountryName }
          : {}),
      };
    } catch (error) {
      console.error("❌ Error validating address:", error);
      return "No Response";
    }
  };

  return { validateSingleAddress };
};
